import { TextInput } from '@mantine/core'
import type { FC } from 'react'

type CustomTextInputProps = {
  name: string
  title: string
  description: string | null
  required: boolean
  error: string | undefined
}

export const CustomTextInput: FC<CustomTextInputProps> = ({
  name,
  title,
  description,
  required,
  error,
}) => {
  return (
    <TextInput
      name={name}
      label={title}
      description={description}
      required={required}
      error={error}
      size='md'
    />
  )
}
